import React, { Component } from "react";
import PropTypes from "prop-types";
import Button from "react-md/lib/Buttons/Button";
import Card from "react-md/lib/Cards/Card";
import CardTitle from "react-md/lib/Cards/CardTitle";
import CardActions from "react-md/lib/Cards/CardActions";
import CardText from "react-md/lib/Cards/CardText";
import moment from "moment";
import { IssueShape } from "../../../../../common/proptypes";

class IssueListItem extends Component {
  constructor(props) {
    super(props);
    this.handleDelete = this.handleDelete.bind(this);
  }

  handleDelete() {
    const { onDelete, issue, customerKey } = this.props;
    onDelete(issue.key, customerKey);
  }

  render() {
    const { issue } = this.props;
    return (
      <Card key={issue.key} className="md-cell md-cell--12">
        <CardTitle
          title={moment(issue.updated).format("M/D/YYYY h:mm a")}
          style={{ padding: 10, paddingBottom: 0 }}
          className="issue-item-title"
        />
        <CardText style={{ whiteSpace: "pre-wrap", padding: 10 }}>
          {issue.text}
        </CardText>
        <CardActions
          className="md-divider-border md-divider-border--top"
          style={{ padding: 4 }}
        >
          <Button
            onClick={this.handleDelete}
            flat
            primary
            style={{ marginLeft: "auto" }}
          >
            Delete
          </Button>
        </CardActions>
      </Card>
    );
  }
}

IssueListItem.propTypes = {
  onDelete: PropTypes.func.isRequired,
  issue: IssueShape.isRequired,
  customerKey: PropTypes.string.isRequired,
};

export default IssueListItem;



// WEBPACK FOOTER //
// ./src/customer/components/EditCustomer/IssueList/IssueListItem/IssueListItem.jsx